
const MAX_FILE_SIZE = 3 * 1024 * 1024;

export class DocumentModel {
  constructor(data) {
    if (data) {
      this.documentId = data.documentId;
      this.fileName = data.fileName;
      this.documentTypeId = data.documentTypeId;
      this.documentTypeDescription = data.documentTypeDescription;
      this.fileType = data.fileType;
      this.fileSize = data.fileSize;
      this.formattedFileSize = DocumentModel.formattedFileSize(data.fileSize);
      this.file = null;
      this.error = data.fileSize > MAX_FILE_SIZE ? 'File size exceeds the maximum limit of 3MB.' : '';
      this.isNew = false;
    }
  }

  static formattedFileSize = (fileSize) => {
    if (!fileSize) {
      return '';
    }

    if (fileSize < 1024) {
      return `${this.fileSize} B`;
    }
    if (fileSize < 1024 * 1024) {
      return `${Math.floor(fileSize / 1024)} KB`;
    }
    return `${Math.floor(fileSize / (1024 * 1024))} MB`;
  };

  static async newDocument(file, documentTypeIdValue, documentTypeDescriptionValue) {
    const document = new DocumentModel();
    document.fileName = file.name;
    document.documentTypeId = documentTypeIdValue;
    document.documentTypeDescription = documentTypeDescriptionValue;
    document.fileType = file.type;
    document.fileSize = file.size;
    document.formattedFileSize = DocumentModel.formattedFileSize(file.size);
    document.file = file;
    document.error = file.size > MAX_FILE_SIZE ? 'File size exceeds the maximum limit of 3MB.' : '';
    document.isNew = true;
    return document;
  }

  static newDocumentNoDocumentType(file) {
    const document = new DocumentModel();
    document.fileName = file.name;
    document.fileType = file.type;
    document.fileSize = file.size;
    document.formattedFileSize = DocumentModel.formattedFileSize(file.size);
    document.file = file;
    document.error = file.size > MAX_FILE_SIZE ? 'File size exceeds the maximum limit of 3MB.' : '';
    document.isNew = true;
    return document;
  }
}